import { render, staticRenderFns } from "./AnchorsList.vue?vue&type=template&id=6f92c183&"
import script from "./AnchorsList.vue?vue&type=script&lang=js&"
export * from "./AnchorsList.vue?vue&type=script&lang=js&"
import style0 from "./AnchorsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports